import React from 'react';
import { useAuth } from '../hooks/use-auth';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { CommonWrapper, CommonTitle } from 'styles/styles';

export default function Home() {
  const auth = useAuth();

  useEffect(() => {
    axios
      .get('/v0/status')
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <CommonWrapper>
      <CommonTitle>HOME</CommonTitle>
      <Flex>
        <Item>
          <Link to="/f0">工程管理システム</Link>
        </Item>
        <Item>
          <Link to="/f1">設備稼働システム</Link>
        </Item>
        {/* <Item>
          <Link to="/f2">Business chat</Link>
        </Item> */}
      </Flex>
      <Submit onClick={() => auth.signOut()}>ログアウト</Submit>
    </CommonWrapper>
  );
}

const Submit = styled.div`
  color: #0094b5;
  border: none;
  cursor: pointer;
  margin-top: 32px;
  text-align: center;
`;

const Item = styled.div`
  width: 320px;
  text-align: center;
  border: black solid 1px;
  color: white black;
  padding: 20px 20px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
`;

const Flex = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, 320px);
  gap: 10px;
`;
